module.exports = __webpack_public_path__ + "static/img/nav-logo.76fa625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/nav-logo.png
// module id = cT9r
// module chunks = 11